export default __webpack_public_path__ + "static/media/Group 3402.d996e2ac.png";